import React, { useEffect, useState } from "react";
import "./App.css";
import "./styles/main.scss";
import { BodySection, Layout } from "./styles/component/style";
import AppRouter from "./AppRoutes";
import Providers from "./providers/Providers";
import Loader from "./components/common/Loader/Loader";
import AlertWrapper from "./components/common/Alert/AlertWrapper";
import ReactGA from "react-ga";
import { globalHistory } from "@reach/router";
import SessionLogout from "./components/common/SessionLogout";
// import Whatsapp from "./components/common/Whatsapp/Whatsapp";

ReactGA.initialize("UA-214190369-1");

function App() {
  // ✅ login state initialized from localStorage
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!localStorage.getItem("token"));
  const [pathname, setPathname] = useState(window.location.pathname);

  // Google Analytics + route tracking
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);

    const unlisten = globalHistory.listen(({ location }) => {
      ReactGA.pageview(location.pathname + location.search);
      setPathname(location.pathname);
    });

    return () => unlisten();
  }, []);

  useEffect(() => {
    const updateLoginStatus = () => {
      setIsLoggedIn(!!localStorage.getItem("token"));
    };

    window.addEventListener("storage", updateLoginStatus); 
    window.addEventListener("authChange", updateLoginStatus); 

    return () => {
      window.removeEventListener("storage", updateLoginStatus);
      window.removeEventListener("authChange", updateLoginStatus);
    };
  }, []);

 
  const landingPagePath = "/"; 

  const shouldShowWhatsapp = !isLoggedIn && pathname === landingPagePath;

  return (
    <Providers>
      <Layout>
        <BodySection>
          <Loader />
          <AlertWrapper />
          <AppRouter />
        </BodySection>

        <SessionLogout />

        {/* {shouldShowWhatsapp && (
          // <Whatsapp
            phoneNumber="9500909888"
            message="Hi, I need help with IAMC"
          />
        )} */}
      </Layout>
    </Providers>
  );
}

export default App;
